module.exports = __webpack_public_path__ + "static/img/language.104948e1.svg";